// lib
import palette from 'lib/styles/palette';
import * as styles from 'lib/styles/styles';
// icons
import { NextIcon, PrevIcon } from 'lib/svg';
import styled from 'styled-components';

const MoveBtn = ({ type, onClick }: Props) => {
  const Icon = type === "PREV"
    ? PrevIcon
    : NextIcon;
  
  const msg = type === "PREV"
    ? "Previous"
    : "Next";

  return (
    <Container onClick={onClick} title={msg}>
      <Content>
        <Icon />
      </Content>
    </Container>
  );
}

const Container = styled.button`
  min-width: 80px;
  height: 100%;
   background-color: ${palette.red2};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
  
  border-radius: 10% ;
 
  
  &:focus, &:hover {
    background-color: ${palette.red3}
  }
`;

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transition: .1s ${styles.transition};
  
  & > svg {
    width: 30px;
    height: 30px;
    filter: invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%);
  }
`;


interface Props {
  type: "PREV" | "NEXT"
  onClick: () => void;
}

export default MoveBtn;